import { Collapse, Space } from 'antd';
import { constants, Investment, Investor, queries } from 'procura-shared';
import React from 'react';
import { useCollectionData } from 'react-firebase-hooks/firestore';
import { useTranslation } from 'react-i18next';
import { ChangeLoginEmailButton } from './ChangeLoginEmailButton';
import { DeleteButton, DetailsTable, InvestmentsTable } from './Components';

type InvestorInfoProps = {
  investor: Investor;
  loading?: boolean;
  adminMode?: boolean;
  onSelect?: (investment: Investment) => void;
};

export const InvestorInfo = ({ investor, loading = false, adminMode = false, onSelect }: InvestorInfoProps) => {
  const { t } = useTranslation();

  const [fbInvestments, fbInvestmentsLoading] = useCollectionData<Investment>(
    queries.investorInvestmentsQuery(investor?.id),
    {
      idField: 'id',
    }
  );

  const investmentSelectHandler = (investment) => onSelect?.(investment);

  return (
    <>
      <Collapse defaultActiveKey={['0', '1']}>
        <Collapse.Panel header={t('information')} key="0">
          <DetailsTable loading={loading} details={investor} keys={constants.INVESTOR_KEYS} adminMode={adminMode} />
        </Collapse.Panel>
        <Collapse.Panel header={t('investments')} key="1">
          <InvestmentsTable
            investments={fbInvestments}
            loading={loading || fbInvestmentsLoading}
            table={false}
            onSelect={investmentSelectHandler}
          />
        </Collapse.Panel>
      </Collapse>
      {adminMode && (
        <Space direction="horizontal" style={{ marginTop: 12 }}>
          <DeleteButton type="Investor" investor={investor} />
          <ChangeLoginEmailButton investor={investor} />
        </Space>
      )}
    </>
  );
};
